import AdditionalTicketInformationList from './AdditionalTicketInformationList';
import { AdditionalTicketInformationListProps, AdditionalTicketInformationListValueProps } from './types';

export type { AdditionalTicketInformationListProps, AdditionalTicketInformationListValueProps };
export default AdditionalTicketInformationList;
